import { create } from "zustand";
import type { MyBet } from "@crashx/shared";
export const useNotificationStore = create<{
  bets: MyBet[];
  push: (bet: MyBet) => void;
  dismiss: (id: string) => void;
}>((set) => ({
  bets: [],
  push: (bet) =>
    set((state) =>
      state.bets.some((known) => known.betId === bet.betId)
        ? state
        : { bets: [...state.bets, bet].slice(-4) },
    ),
  dismiss: (id) => set((state) => ({ bets: state.bets.filter((bet) => bet.betId !== id) })),
}));
